import { useNavigate } from 'react-router-dom';
import { Command } from 'cmdk';
import { t } from 'src/i18n';
import IconArrowForward from '../../../assets/svg/icon-arrow-forward.svg';
import IconArrowForwardAncestors from '../../../assets/svg/icon-arrow-forward-small.svg';
import { getRedirectLink } from '../utils';
import { StyledResultItem, ResultIcon, ResultContent, ResultArrow, Ancestors } from './resultItem.style';

function ResultItem({
  children,
  value,
  subtitle,
  icon,
  toggleGlobalSearchVisibility,
  id,
  type,
  company,
  clickItem,
  documentId,
  ancestors,
  workerIdentityId,
}) {
  const navigate = useNavigate();
  const translatedSubtitle = t(`dash.globalSearch.type_labels.${type.toLowerCase()}`, subtitle);

  const ancestorsPath =
    ancestors && ancestors.length > 0 ? (
      <Ancestors className="result-content-ancestors">
        {ancestors.map((ancestor, index) => (
          <span key={ancestor} className="ancestor-item">
            {' '}
            {index > 0 && <img alt="" src={IconArrowForwardAncestors} className="ancestor-separator-icon" />} {ancestor}
          </span>
        ))}
      </Ancestors>
    ) : null;

  return (
    <Command.Item
      value={value}
      onSelect={() => {
        clickItem({ id: documentId });
        navigate(getRedirectLink(type, id, company, workerIdentityId));
        toggleGlobalSearchVisibility();
      }}
      shouldFilter="false"
    >
      <StyledResultItem>
        <ResultIcon className="result-icon">{icon}</ResultIcon>

        <ResultContent className="result-content">
          <span className="result-content-title">{children}</span>
          <span className="result-content-subtitle">{ancestorsPath || translatedSubtitle}</span>
        </ResultContent>
      </StyledResultItem>
      <ResultArrow>
        <img alt="" src={IconArrowForward} className="result-arrow" />
      </ResultArrow>
    </Command.Item>
  );
}

export default ResultItem;
